export default [
  {
    header: 'Báo cáo thống kê',
    resource: 'report',
    action: 'read',
  },
  {
    title: 'Thống kê khoản thu',
    route: 'report-by-service-type',
    icon: 'BarChartIcon',
    resource: 'report-by-service-type',
    action: 'read',
    children: [
      {
        title: 'Khoản thu theo lớp và loại dịch vụ',
        route: { name: 'report-by-service-type-1', query: { type: '1' } },
        icon: ' ',
        resource: 'report-by-service-type',
        action: 'read'
      },
      {
        title: 'Khoản thu theo lớp và dịch vụ',
        route: { name: 'report-by-service-type-2', query: { type: '2' } },
        icon: ' ',
        resource: 'report-by-service-type',
        action: 'read'
      },
      {
        title: 'Khoản thu theo học sinh và dịch vụ',
        route: { name: 'report-by-service-type-4', query: { type: '4' } },
        icon: ' ',
        resource: 'report-by-service-type',
        action: 'read'
      },
      {
        title: 'Tổng hợp khoản thu',
        route: { name: 'report-by-service-type-3', query: { type: '3' } },
        icon: ' ',
        resource: 'report-by-service-type',
        action: 'read'
      },

    ]
  },

];

// export default [
//   {
//     header: 'Báo cáo thống kê',
//     resource: 'report',
//     action: 'read',
//   },
//   {
//     title: 'Thống kê khoản thu',
//     route: 'report-by-service-type',
//     icon: 'BarChartIcon',
//     resource: 'report-by-service-type',
//     action: 'read',
//   },
// ];
